export default "__VITE_ASSET__am0Wetij__"